<template>
  <b-container fluid>
    <b-row hidden>
      <b-col>1</b-col>
      <b-col>2</b-col>
      <b-col>3</b-col>
      <b-col>4</b-col>
      <b-col>5</b-col>
      <b-col>6</b-col>
      <b-col>7</b-col>
      <b-col>8</b-col>
      <b-col>9</b-col>
      <b-col>10</b-col>
      <b-col>11</b-col>
      <b-col>12</b-col>
    </b-row>

    <b-row align-h="center">
      <b-col cols="12" sm="8" lg="4">
        <div class="page-header">
          <h2>{{ msg }}</h2>
        </div>Unable to locate this resource.
        <div>
          <b-link to="/login">Home</b-link>
        </div>
      </b-col>
    </b-row>
    <div v-if="debug">
      <h2 v-once>s: {{ studentHash }}</h2>
      <h2 v-once>c: {{ classHash }}</h2>
    </div>
  </b-container>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";

var data = {
  msg: "Page Not Found",
  show: true,
  debug: false,
  loading: true,
  error: false,
  studentHash: "",
  classHash: "",
  form: { username: "", password: "" }
};

// using props for url parameters
// https://www.youtube.com/watch?v=ESg0k2zdME4

export default {
  name: "NotFound",
  data() {
    return data;
  },
  props: {
    // route set to use props mapped to url parameters
    s: {
      type: String,
      default: ""
    },
    c: {
      type: String,
      default: ""
    }
  },
  methods: {  }
};

function handleInit(data) {
  console.log(`status: ${data.status}`);
  console.log(`studentHash: ${studentHash}`);
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue